import { Box, Chip, Container, Link, Tooltip, Typography } from '@material-ui/core';

const platformIcons = {
  Logo: '/static/youxuan_logo.png',
};

const AuthBanner = () => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      borderBottom: 1,
      borderColor: 'divider',
      py: 2
    }}
  >
    <Container maxWidth="md">
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center'
        }}
      >

        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            ml: 2,
            '& > img': {
              height: 30,
              mx: 2
            }
          }}
        >
          <Typography
            color="textPrimary"
            variant="subtitle2"
          >
             BO智学运营管理系统
          </Typography>

        </Box>
      </Box>
    </Container>
  </Box>
);

export default AuthBanner;
